import React, { useState, useCallback, useMemo } from "react";
import constate from "constate";
import useUserAgent from "../../../hooks/useUserAgent.js";
import { useTheme, useViewport } from "@bookingcom/bui-react";
import styles from "./Wrapper.module.css";
import useIsPostBookingRoute from "../../../hooks/useIsPostBookingRoute.js";
const defaultProps = {
    noBorder: false,
    noPadding: false,
    noPaddingVertical: false,
    style: {}
};
export default function Wrapper(props) {
    const { noBorder, noPadding, style, children, noPaddingVertical, elementRef } = { ...defaultProps, ...props };
    const theme = useTheme();
    const { isMobile } = useUserAgent();
    const { isSmall } = useViewport();
    const isPostBooking = useIsPostBookingRoute();
    const defaultBorderStyles = useMemo(() => {
        if (noBorder) {
            return {};
        }
        if (isMobile) {
            return { borderBottom: `${theme.units.border_width_100} solid ${theme.colors.color_border_alt}` };
        }
        else {
            return {
                border: `${theme.units.border_width_100} solid ${theme.colors.color_border_alt}`,
                borderRadius: theme.units.border_radius_100
            };
        }
    }, [isMobile, noBorder, theme.colors.color_border_alt, theme.units.border_radius_100, theme.units.border_width_100]);
    const paddingVertical = noPaddingVertical
        ? 0
        : isMobile || (!isPostBooking && isSmall)
            ? theme.units.spacing_4x
            : theme.units.spacing_6x;
    const paddingHorizontal = noPadding ? 0 : paddingVertical;
    const defaultPaddingStyles = useMemo(() => ({
        paddingLeft: paddingHorizontal,
        paddingRight: paddingHorizontal,
        paddingTop: paddingVertical,
        paddingBottom: paddingVertical
    }), [paddingHorizontal, paddingVertical]);
    return (React.createElement(WrapperProvider, { padding: paddingHorizontal, inlineStyles: { ...defaultPaddingStyles, ...defaultBorderStyles, ...style }, elementRef: elementRef },
        React.createElement(WrapperRenderer, null, children)));
}
function WrapperRenderer(props) {
    const { render, inlineStyles, elementRef } = useWrapperContext();
    const { padding } = useWrapperContext();
    if (!render)
        return null;
    return (React.createElement("div", { style: { padding, ...inlineStyles }, className: styles.root, ref: elementRef }, props.children));
}
function useWrapperProvider(props) {
    const [render, setRender] = useState(true);
    const dismiss = useCallback(() => {
        setRender(false);
    }, [setRender]);
    const { padding, inlineStyles, elementRef } = { ...defaultProps, ...props };
    return {
        padding,
        inlineStyles,
        elementRef,
        render,
        dismiss
    };
}
const [WrapperProvider, useWrapperContext] = constate(useWrapperProvider);
export { WrapperProvider, useWrapperContext };
